/**
 * Single source of truth for LaunchDarkly flag defaults.
 * No imports — safe to use in both browser and Node (build-time) contexts.
 * `launch-darkly-config.ts` re-exports this for the app.
 * Fixture files import this directly for screenshot generation.
 */
export const fallbackFlags = {
  // operational
  'show-application-maintenance-mode': false,
  'show-price-cap': false,
  'show-operational-alert': false,
  'show-cross-sell-offer': false,

  // journeys
  'allow-journey-default': true,
  'allow-journey-voicesales-homemove': true,
  'allow-journey-voicesales-winback': true,
  'allow-journey-voicesales-aquisition': true,
  'allow-journey-nondomestic-transfer': true,
  'allow-journey-move-in': true,
  // release
  'release-solar-registration': false,
  'release-abandoned-cart': false,
  'release-ev-quote': false,
  'release-ev-quote-voice-sales': false,
  'release-quoting-ev-for-home-move-journey': false,
  'release-peak-save-journey': false,
  'release-exception-screen-title-update': true,
  'release-ev-info-redesign': false,
  'release-update-meter-reading-frequency-question': false,
  'release-choose-bg-screen': false,
  'release-winback-remove-bill-credit-dropdown': false,
  'release-fnf-voice-sales-description': false,
  'release-vat-removal-message': false,
  'release-price-cap-new-design': false,

  'experiment-direct-debit-new-validation': false,
  'experiment-cross-sales-export-NTB': false,
  'experiment-early-exit-update': false,
  'experiment-price-sensitivity-quote': false,
  'experiment-move-in-redirect': false,
  'experiment-exit-fee-wording': false,
  'experiment-electralink': {
    value: 'A'
  },
  'experiment-remove-list-table-filter': false,
  'experiment-steps-update': false,
  'experiment-two-tariff-view': false
} as const;
